import { useMemo, useState } from "react";
import { useLang } from "../../lib/LanguageContext";
import { Slider } from "../ui/slider";

const fmtIDR = (n) => "Rp " + n.toLocaleString("id-ID");

export default function MarginCalculator() {
  const { t } = useLang();
  const [wholesale, setWholesale] = useState(50000);
  const [retail, setRetail] = useState(149000);
  const [qty, setQty] = useState(80);

  const { profit, margin } = useMemo(() => {
    const p = (retail - wholesale) * qty;
    const m = retail > 0 ? Math.round(((retail - wholesale) / retail) * 100) : 0;
    return { profit: Math.max(0, p), margin: Math.max(0, m) };
  }, [wholesale, retail, qty]);

  return (
    <div className="rounded-2xl bg-white/5 border border-white/10 p-5 backdrop-blur" data-testid="margin-calculator">
      <div className="space-y-5">
        <div>
          <div className="flex justify-between mb-2">
            <label className="text-xs font-semibold text-white/70">{t.features.calcWholesale}</label>
            <span className="text-xs font-bold text-white">{fmtIDR(wholesale)}</span>
          </div>
          <Slider
            data-testid="calc-wholesale-slider"
            value={[wholesale]}
            min={10000}
            max={500000}
            step={5000}
            onValueChange={(v) => setWholesale(v[0])}
          />
        </div>

        <div>
          <div className="flex justify-between mb-2">
            <label className="text-xs font-semibold text-white/70">{t.features.calcRetail}</label>
            <span className="text-xs font-bold text-white">{fmtIDR(retail)}</span>
          </div>
          <Slider
            data-testid="calc-retail-slider"
            value={[retail]}
            min={wholesale}
            max={1000000}
            step={5000}
            onValueChange={(v) => setRetail(v[0])}
          />
        </div>

        <div>
          <div className="flex justify-between mb-2">
            <label className="text-xs font-semibold text-white/70">{t.features.calcQty}</label>
            <span className="text-xs font-bold text-white">{qty} pcs</span>
          </div>
          <Slider
            data-testid="calc-qty-slider"
            value={[qty]}
            min={10}
            max={500}
            step={10}
            onValueChange={(v) => setQty(v[0])}
          />
        </div>

        <div className="mt-4 pt-5 border-t border-white/10 grid grid-cols-2 gap-3">
          <div className="rounded-xl bg-brand-orange/15 border border-brand-orange/30 p-4">
            <div className="text-[10px] font-bold uppercase tracking-wider text-brand-orange">{t.features.calcProfit}</div>
            <div className="font-display text-xl sm:text-2xl font-extrabold text-brand-orange mt-1" data-testid="calc-profit">
              {fmtIDR(profit)}
            </div>
          </div>
          <div className="rounded-xl bg-white/5 border border-white/10 p-4">
            <div className="text-[10px] font-bold uppercase tracking-wider text-white/70">{t.features.calcMargin}</div>
            <div className="font-display text-xl sm:text-2xl font-extrabold text-white mt-1" data-testid="calc-margin">
              +{margin}%
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
